import React from "react";
const Contact = () => {
  return (
    <>
      <section className='contact-section' data-aos="fade-left">
        <p className="contact-head-title">
          Got a business idea<br/>
          you want to build?<br/>
        </p>
        <p className="love-to-hear" data-aos="fade-left">
          We can help you to develop the business and<br/>
          increase your online visibility to reach<br/>
          more potential audience
        </p>
        <div className="contact-us-btn">Contact Us</div>
    </section>
    <section id="contact-body">
      <h1 data-aos="fade-left">Contact us to give you<br/>
         quality brand
      </h1>
      <article className="contact-details-holder" data-aos="fade-left">
        <p className="phone-number">PHONE NUMBER</p>
        <p className="open-time">
          Our customer care is open from <br/>
          Mon-Fri, 09:00 am to 5:00 pm
        </p>
        <p className="phone-number-digit">
          NG: +234 7061 6189 72
        </p>
        <p className="email">EMAIL</p>
        <p className="support">
          Our support team will respond<br/>
          within 48 hours.
        </p>
        <p className="phone-number-digit">
          iwuanyanwuaugustine@gmail.com
        </p>
      </article>
      <h1 className="our-office" data-aos="fade-left">Our Office</h1>
      <article id="address" data-aos="fade-left">
        <p>
          <strong>Port Harcourt</strong>
          <p>
            13 wiche lane off uniport Road, Choba, 500102<br/>
            Nigeria
          </p>
        </p>
      </article>
    </section>
    </>
  );
};
export default Contact;
